module.exports = __webpack_public_path__ + "static/media/NG.2a45c408.png";